module.exports = __webpack_public_path__ + "img/98.0bc5a215.jpg";